<template>
  <div>
    <v-alert type="success" color="green" v-if="message" dismissible>{{message}}</v-alert>
    <v-dialog v-model="dialog" max-width="500px" v-if="openRequest.length==0">
      <template v-slot:activator="{on}">
        <v-btn small v-on="on" class="primary themed">Demander des fonds à votre manager</v-btn>
      </template>
      <v-card>
        <v-card-title>Demande de fonds à votre manager</v-card-title>
        <v-card-text>
          <v-alert type="error" v-if="error">{{error}}</v-alert>
          <v-row>
            <v-col cols="12">Vous pouvez demander des fonds à votre manager direct.</v-col>
          </v-row>
          <v-row>
            <v-col>
              <v-text-field
                type="number"
                v-model="model.amount"
                :rules="[mandatoryRules]"
                label="Montant"
              ></v-text-field>
            </v-col>
          </v-row>
          <v-row>
            <v-col>
              <v-textarea label="Justificatif" v-model="model.comment"></v-textarea>
            </v-col>
          </v-row>
        </v-card-text>
        <v-card-actions>
          <v-btn class="themed" small @click="close()">Annuler</v-btn>
          <v-spacer />
          <v-btn class="themed" small color="primary" @click="submit()">Envoyer</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-data-table v-else :items="openRequest" :headers="moneyRequestHeaders" hide-default-footer>
      <template v-slot:top>Demande en court</template>
      <template v-slot:item.amount="{item}">{{$format.money(item.amount)}}</template>
      <template v-slot:item.manager="{item}">{{item.manager.firstname}} {{item.manager.lastname}}</template>
    </v-data-table>
  </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
export default {
  data: () => ({
    dialog: false,
    model: {},
    error: null,
    mandatoryRules: v => !!v || "Ce champ est obligatoire",
    message: null,
    moneyRequestHeaders: [
      { text: "Date", value: "date" },
      { text: "Montant", value: "amount" },
      { text: "Manager", value: "manager" }
    ]
  }),
  computed: {
    ...mapGetters("auth", ["currentUser"]),
    openRequest() {
      if (this.currentUser && this.currentUser.moneyRequests) {
        return this.currentUser.moneyRequests.filter(
          request => request.status == "asked"
        );
      }
      return [];
    }
  },
  methods: {
    ...mapActions("moneyRequest", ["request"]),
    close() {
      this.model = {};
      this.error = null;
      this.dialog = false;
    },
    submit() {
      this.error = null;
      this.request(this.model)
        .then(() => {
          this.message = "Votre demande a été envoyée";
          this.close();
        })
        .catch(error => {
          this.error = error.error;
        });
    }
  }
};
</script>

<style>
</style>